import React from "react";
import { Flex, FormControl, Image, Text, Wrap, WrapItem } from "@chakra-ui/react";
import { FaBullseye } from "react-icons/fa";
import { FaMoneyBills } from "react-icons/fa6";
import { Trans } from "@lingui/macro";

import Button from "../../components/Button";
import MinAmountInfo from "../../components/MinAmountInfo";
import { formatMoney } from "../../utils";

const CARD_COLORS = [
  "saweria-yellow.normal",
  "saweria-green.normal",
  "saweria-pink.normal",
  "#A1C8FF",
];

const ImagePlaceholder = () => (
  <Flex
    w="80px"
    h="84px"
    flexShrink={0}
    align="center"
    justify="center"
    bg="#EAEFED"
    border="1px solid black"
    borderRadius="6px"
  >
    <FaBullseye size={28} />
  </Flex>
);

// One challenge per donation; `challenge` comes from getChallenge (DonationForm).
const ChallengeSelector = ({ challenge, currency, onToggle }) => {
  const { items, isFilled, unmetMinimums } = challenge;
  if (!items.length) return null;

  return (
    <FormControl mb={3}>
      <Text fontFamily="IBM Plex Mono" fontSize="16px" fontWeight="500" mb={2}>
        <Trans>Challenge:</Trans>
      </Text>
      <Wrap spacing="16px">
        {items.map(({ slug, title, image, price, isAvailable, isSelected }, index) => (
          <WrapItem key={slug}>
            <Button
              type="button"
              data-testid={`challenge-${slug}`}
              aria-pressed={isSelected}
              pressed={isSelected}
              disabled={!isAvailable}
              backgroundColor={CARD_COLORS[index % CARD_COLORS.length]}
              filter={isAvailable ? "none" : "grayscale(75%)"}
              paddingX={4}
              paddingY={3}
              marginBottom={2}
              textAlign="left"
              onClick={() => {
                if (!isAvailable) return;
                onToggle(slug);
              }}
              label={
                <Flex align="center" gap="12px">
                  <Image
                    src={image || undefined}
                    alt=""
                    w="80px"
                    h="84px"
                    flexShrink={0}
                    objectFit="cover"
                    borderRadius="6px"
                    border="1px solid black"
                    fallback={<ImagePlaceholder />}
                  />
                  <Flex
                    direction="column"
                    gap="8px"
                    fontFamily="IBM Plex Mono"
                    fontSize="16px"
                    lineHeight="24px"
                    color="black"
                  >
                    <Text as="span" fontWeight={600}>
                      {title}
                    </Text>
                    <Text as="span" fontWeight={400}>
                      {`+${formatMoney(price, { currency })}`}
                    </Text>
                  </Flex>
                </Flex>
              }
            />
          </WrapItem>
        ))}
      </Wrap>
      {isFilled && unmetMinimums.length > 0 && (
        <MinAmountInfo
          labels={unmetMinimums.map((c) => `Min. ${c.title}:`)}
          amounts={unmetMinimums.map((c) => c.min_donate)}
          currency={currency}
          reactIcon={FaMoneyBills}
        />
      )}
    </FormControl>
  );
};

export { ChallengeSelector };
